import { Box } from '@mui/material';
import React from 'react';

const browserWindowSx = {
  borderRadius: '6px',
  border: '1px solid #adadad',
  boxShadow: { xs: '0 5px 20px rgba(0, 0, 0, 0.55)', md: '0 20px 70px rgba(0, 0, 0, 0.55)' },
  mx: 'auto',
  overflow: 'hidden',
};

const browserBarSx = {
  borderTopLeftRadius: '6px',
  borderTopRightRadius: '6px',
  color: '#505151',
  fontSize: 12,
  fontWeight: 'bold',
  background:
    'radial-gradient(7px at 14px 50%, #ff5e57 0px, #ff635a 5px, #fd5249 6px, rgba(255, 255, 255, 0) 7px), radial-gradient(7px at 34px 50%, #ffbd2e 0px, #ffc42f 5px, #fcb91b 6px, rgba(255, 255, 255, 0) 7px), radial-gradient(7px at 54px 50%, #62c755 0px, #65CC57 5px, #54B542 6px, rgba(255, 255, 255, 0) 7px), #ffffff',
  height: 40,
  display: 'flex',
  alignItems: 'center',
};

const browserTrafficLightsSpacerSx = {
  width: 70,
  flexShrink: 0,
};

const browserNavigationSx = {
  flex: 1,
  maxWidth: '60%',
  bgcolor: '#fafaf9',
  height: '1.6rem',
  borderRadius: '0.5rem',
};

const browserFrameSx = {
  display: 'block',
  bgcolor: '#fff',
  width: '100%',
};

function BrowserWindow({ children, className }) {
  return (
    <Box sx={browserWindowSx} className={className}>
      <Box sx={browserBarSx}>
        <Box sx={browserTrafficLightsSpacerSx} aria-hidden />
        <Box sx={browserNavigationSx} />
        <Box sx={browserTrafficLightsSpacerSx} aria-hidden />
      </Box>
      <Box sx={browserFrameSx}>{children}</Box>
    </Box>
  );
}

export default BrowserWindow;
